import React, { useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css";

function Home() {
  const navigate = useNavigate();

  // 👇 Reference for scrolling
  const servicesRef = useRef(null);

  return (
    <div>
      <Navbar />

      
      <section className="hero" data-aos="fade-up">
        <div className="hero-content">
          <h1>Explore the World with Bomander Travels</h1>
          <p>
            Your trusted partner for visas, study abroad & global travel solutions
          </p>

          
          <button
            onClick={() =>
              servicesRef.current.scrollIntoView({ behavior: "smooth" })
            }
          >
            Get Started
          </button>
        </div>
      </section>

      
      <section
        className="services"
        data-aos="fade-up"
        ref={servicesRef} // 
      >
        <h2>Our Services</h2>

        <div className="service-container">

          
          <div className="card" data-aos="zoom-in">
            <img
              src="https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=600&auto=format&fit=crop&q=60"
              alt="Tourism"
              loading="lazy"
            />
            <h3>Tourism / Visitor Visa</h3>
            <p>
              Explore the world with ease. We handle your travel visa process smoothly.
            </p>

            <button
              className="card-btn"
              onClick={() => navigate("/tourism")}
            >
              Learn More
            </button>
          </div>

          
          <div className="card" data-aos="zoom-in" data-aos-delay="100">
            <img
              src="https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=600&auto=format&fit=crop&q=60"
              alt="Study"
              loading="lazy"
            />
            <h3>University Admission / Study Visa</h3>
            <p>
              Get admission into top universities abroad with our expert guidance.
            </p>

            <button
              className="card-btn"
              onClick={() => navigate("/study")}
            >
              Learn More
            </button>
          </div>

          
          <div className="card" data-aos="zoom-in" data-aos-delay="200">
            <img
              src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=600&auto=format&fit=crop&q=60"
              alt="Work"
              loading="lazy"
            />
            <h3>Work Sponsorship Visa</h3>
            <p>
              Secure international jobs and sponsorship opportunities with ease.
            </p>

            <button
              className="card-btn"
              onClick={() => navigate("/work")}
            >
              Learn More
            </button>
          </div>

          
          <div className="card" data-aos="zoom-in" data-aos-delay="300">
            <img
              src="https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=600&auto=format&fit=crop&q=60"
              alt="Conference"
              loading="lazy"
            />
            <h3>Academic Conference Application</h3>
            <p>
              Attend global conferences and expand your academic network.
            </p>

            <button
              className="card-btn"
              onClick={() => navigate("/conference")}
            >
              Learn More
            </button>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Home;